import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = makeStyles((theme) => ({
  error: {
    fontSize: "1.2em",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    textAlign: ({ textAlign }: any) => {
      return textAlign;
    },
  },
}));

export default function Error({ error = null, textAlign = "center" }) {
  const classes = useStyles({ textAlign });

  return (
    <FormHelperText error className={classes.error}>
      {error}
    </FormHelperText>
  );
}
